<template>
  <div class="tolead" @mousewheel.prevent="rollImg">
    <img v-if="checkedFile.Suffix === '.jpg' || checkedFile.Suffix === '.jpeg' || checkedFile.Suffix === '.png'"
      :src="checkedFile.Path" class="img" ref="imgDiv" @mousedown="move" />

    <div class="title">
      <div class="left">
        <div style="margin-right: 10px; display: flex; align-items: center" class="project">
          <span style="width: 80px">项目:</span>
          <el-select v-model="value" value-key="Id" placeholder="请选择" @change="ProjectChange"
            :class="{ classborder: border == 1 }">
            <el-option v-for="(item, index) in Project" :key="index" :label="item.Name" :value="item"></el-option>
          </el-select>
        </div>
        <div style="width: 270px; display: flex; align-items: center" class="KeyWord">
          <span style="width: 80px">关键字</span>
          <el-input type="text" v-model="keyword" style="width: 200px" />
        </div>
        <div style="display: flex; align-items: center" class="timer">
          <span style="width: 80px">开始时间:</span>
          <el-date-picker v-model="StartTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
            size="small"></el-date-picker>
          <span style="width: 80px">结束时间:</span>
          <el-date-picker v-model="EndTime" type="date" size="large" value-format="yyyy-MM-dd"
            placeholder="选择日期"></el-date-picker>
        </div>
        <div style="margin-right: 10px; display: flex; align-items: center">
          <el-button @click="query" icon="el-icon-search" type="primary">查询</el-button>
          <el-button @click="Reset" class="czhi">
            <img src="../../assets/image/icon/czhi.png" alt style="width: 14px; height: 14px" />
            重置
          </el-button>
        </div>
        <div>
          <span class="yuan" style="width: 500px">
            <!-- <span style="width:20px;height:20px;background:#3fbc39;border-radius: 50%;"></span> -->
            <img src="../../assets/image/RisiSafe.png" style="width: 20px; height: 20px" />
            <!-- <el-tag color="#3fbc39"  effect="dark"> </el-tag> -->
            <span style="margin-right: 20px">正常</span>
            <!-- <span style="width:20px;height:20px;background:#f6d10e;border-radius: 50%;"></span> -->
            <img src="../../assets/image/RisiWarn.png" style="width: 20px; height: 20px" />
            <!-- <el-tag color="#f6d10e"  effect="dark"> </el-tag> -->
            <span style="margin-right: 20px">低风险</span>
            <!-- <span style="width:20px;height:20px;background:#fd9133;border-radius: 50%;"></span> -->
            <img src="../../assets/image/RisiWarning.png" style="width: 20px; height: 20px" />
            <!-- <el-tag color="#fd9133"  effect="dark"> </el-tag> -->
            <span style="margin-right: 20px">中风险</span>
            <!-- <span style="width:20px;height:20px;background:#ff3f3f;border-radius: 50%;"></span> -->
            <img src="../../assets/image/RisiDanger.png" style="width: 20px; height: 20px" />
            <!-- <el-tag color="#ff3f3f"  effect="dark"> </el-tag> -->
            <span style="margin-right: 20px">高风险</span>
          </span>
        </div>
      </div>
      <div class="right" style="height: 34px">
        <div style="display: flex" v-if="admin != '00000000-0000-0000-0000-000000000000'">
          <div>
            <add-patient :type="1" @AddSonToFather="Addfather" :project="value"></add-patient>
          </div>
          <add-label :ProjectPatientId="activityMultipleSelection[0]" @AddLabelFn="AddFn" @DelLabelFn="DelFn"></add-label>
          <el-button @click="dialAll" type="primary">+AI外呼</el-button>
          <!-- <al-phone></al-phone> -->
          <!-- <message-follow></message-follow> -->
        </div>
        <div v-if="admin != '00000000-0000-0000-0000-000000000000'">
          <input type="file" ref="file" accept=".xls, .xlsx" title @change="getFile" class="se2" />
          <el-button @click="chooseFile" class="dao-ru">
            <img src="../../assets/image/icon/daoru.png" />
            导入EXCEL
          </el-button>
          <el-button @click="TemplateDownload" class="export-img-btn">
            <img src="../../assets/image/icon/xiazai.png" alt />
            <span>模板下载</span>
          </el-button>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="con">
        <el-table ref="multipleTable" :data="PatientTable" style="width: 98%; margin: 0 auto; overflow: hidden !important"
          height="100%" :header-cell-style="{ 'text-align': 'center', background: 'rgb(240, 247, 253)' }" border
          @select="selectAll" @select-all="arrselectAll">
          <!-- @select-all="selectAll"
          @selection-change="handleActivitySelectionChange"-->
          <el-table-column type="selection" min-width="30" align="center"></el-table-column>
          <el-table-column v-if="admin == '00000000-0000-0000-0000-000000000000'" prop="OrganizationName" label="组织名称"
            min-width="80" align="center"></el-table-column>
          <el-table-column label="项目编号" min-width="60" align="center">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.ProjectName" placement="top">
                <p>{{ scope.row.ProjectNo }}</p>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="No" label="患者编号" min-width="60" align="center"></el-table-column>
          <el-table-column label="电话" min-width="110" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.Tel }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="RiskRating" :sortable="true" :sort-method="sortByRisk" label="风险" min-width="80"
            align="center">
            <template slot-scope="scope">
              <!-- <el-tag
                :color="
                  scope.row.RiskRating == '01' || scope.row.RiskRating==null
                    ? '#3fbc39'
                    : scope.row.RiskRating == '02'
                    ? '#f6d10e'
                    : scope.row.RiskRating == '03'
                    ? '#fd9133'
                    : scope.row.RiskRating == '04'
                    ? '#ff3f3f'
                    : ''
                "
                effect="dark"
                disable-transitions
              ></el-tag>-->
              <img v-if="scope.row.RiskRating == '01' || scope.row.RiskRating == null"
                src="../../assets/image/RisiSafe.png" style="width: 20px; height: 20px" />
              <img v-if="scope.row.RiskRating == '02'" src="../../assets/image/RisiWarn.png"
                style="width: 20px; height: 20px" />
              <img v-if="scope.row.RiskRating == '03'" src="../../assets/image/RisiWarning.png"
                style="width: 20px; height: 20px" />
              <img v-if="scope.row.RiskRating == '04'" src="../../assets/image/RisiDanger.png"
                style="width: 20px; height: 20px" />
            </template>
          </el-table-column>
          <el-table-column prop="Name" label="姓名" :sortable="true" :sort-method="sortByVesselName" min-width="100px"
            align="center" fixed></el-table-column>

          <el-table-column label="证件号" min-width="200" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.CertNo }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="AttendingDoctor" label="主治医师" min-width="70" align="center">
          </el-table-column>-->
          <el-table-column label="性别" min-width="100" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.Sex == 1 ? '男' : '' }}</p>
              <p>{{ scope.row.Sex == 0 ? '女' : '' }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="Age" label="年龄" sortable min-width="100" align="center"></el-table-column>
          <el-table-column prop="Birthday" label="出生日期" sortable min-width="180" align="center"></el-table-column>
          <el-table-column prop="DischargeDiagnosis" label="出院诊断" min-width="180" align="center"></el-table-column>
          <el-table-column prop="SecondaryDiagnosis" label="次要诊断" min-width="180" align="center"></el-table-column>
          <el-table-column prop="CreateTime" label="创建时间" sortable min-width="180" align="center"></el-table-column>
          <el-table-column label="患者标签" min-width="100" align="center">
            <template slot-scope="scope">
              <span v-for="(item, index) in scope.row.LabelNameList" :key="index" class="tag_span">{{ item }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="RandomNumber" label="随机号" min-width="100" align="center"></el-table-column>
          <el-table-column prop="GroupNumber" label="组别号" min-width="100" align="center"></el-table-column>
          <!-- 随访记录 -->
          <!-- <el-table-column prop="PatientLabel" label="随访详情" min-width="100" align="center" fixed="right">
             <template slot-scope="scope">
                  <el-link
                  :underline="false"
                  @click="FollowUpRecords(scope.row)"
                >随访记录</el-link>
             </template>
          </el-table-column>-->
          <!-- 患者头像 -->
          <!-- <el-table-column prop="patient" label="患者画像" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <img  @click="PatientPortrait(scope.row)" src="../../assets/image/icon/patient-touxiang.png" alt=""
              >
            </template>
          </el-table-column>-->

          <!-- <el-table-column prop="patient" label="患者画像" width="90" align="center">
            <template slot-scope="scope">
              <img  @click="PatientPortrait(scope.row)" src="../../assets/image/icon/patient-touxiang.png">
            </template
            >
          </el-table-column>-->
          <!-- 问卷填写 -->
          <!-- <el-table-column prop="PatientLabel" label="填写问卷" min-width="100" align="center"  v-if="admin!='00000000-0000-0000-0000-000000000000'" fixed="right">
             <template slot-scope="scope">
                  <el-link
                  :underline="false"
                  @click="QuestionnaireFilling(scope.row)"
                >问卷填写</el-link
                >
             </template>
          </el-table-column>-->
          <el-table-column label="操作" :min-width="!devicePixelRatio ? '250' : '140'" class="edit-info"
            v-if="admin != '00000000-0000-0000-0000-000000000000'" fixed="right">
            <template slot-scope="scope">
              <!-- <el-link-->
              <!--                style="margin-right: 14px"-->
              <!--                :underline="false"-->
              <!--                @click="information(scope.$index, scope.row)"-->
              <!--              ><i class="el-icon-edit-outline"></i>修改</el-link -->
              <!--              > -->
              <div style="display: flex; flex-wrap: wrap; justify-content: space-between; padding: 0 10px">
                <!-- v-has="'Patient/Edt'" -->
                <el-link :underline="false" @click="QuestionnaireFilling(scope.row)" style>
                  <div style="display: flex; align-items: center">
                    <img style="width: 16px; height: 16px; margin-top: 2px" src="../../assets/image/icon/FillIn2.png"
                      alt />
                    新增问卷
                  </div>
                </el-link>
                <el-link :underline="false" @click="FollowUpRecords(scope.row)" style>
                  <div style="display: flex; align-items: center">
                    <img style="width: 16px; height: 16px; margin-top: 3px" src="../../assets/image/icon/takeNotes1.png"
                      alt />
                    随访记录
                  </div>
                </el-link>
                <el-link @click="PatientPortrait(scope.row)" :underline="false" style>
                  <div style="display: flex; align-items: center">
                    <img style="width: 16px; height: 16px; margin-top: 1px"
                      src="../../assets/image/icon/PatientPortrait2.png" alt />
                    患者画像
                  </div>
                </el-link>
                <el-link @click="AddPatientDialog(scope.row)" type="primary" :underline="false">
                  <i class="el-icon-edit-outline"></i>
                  修改
                </el-link>
                <el-link :underline="false" style @click="DeletePatient(scope.row)">
                  <i class="el-icon-delete"></i>
                  删除
                </el-link>

                <!-- <el-link  style="margin-left: 11px" @click="AddRobotIdDialog(scope.row)" type="primary" :underline="false"><i class="el-icon-phone-outline"></i>拨打</el-link> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="width: 98%; margin: 0 auto">
        <Pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.rows"
          @pagination="ProjectGetPageList(value.Id)"></Pagination>
      </div>
      <add-patient :type="2" @EditSonToFather="Editfather" :item="PatientList" v-if="dialogFlag"
        :dialog="dialogFlag"></add-patient>
      <div class="QuestionnaireTable">
        <el-dialog :visible.sync="dialogVisible" width="30%">
          <div slot="title">
            <span style="color: #fff">问卷填写</span>
          </div>
          <div>
            <p style="font-size: 16px; margin-bottom: 10px">问卷列表</p>
            <el-select v-model="Qval" placeholder="请选择" @change="QuestionnaireTableChange" style="margin-bottom: 10px">
              <el-option v-for="(item, index) in QuestionnaireTable" :key="index" :label="item.questionnaireName"
                :value="item.Id"></el-option>
            </el-select>
          </div>
          <div style="width: 100%">
            <p style="font-size: 16px; margin-bottom: 10px">访视次数</p>
            <el-input v-model="CObj" placeholder="请输入内容"></el-input>
          </div>
          <div slot="footer" class="btn">
            <button @click="dialogVisible = false">取 消</button>
            <button type="primary" @click="determine">确 定</button>
          </div>
        </el-dialog>
      </div>
      <div class="QuestionnaireFilling">
        <el-dialog :visible.sync="QuestionnaireFillingDialog" fullscreen @close="handleClose">
          <div class="question" :class="isShow ? '' : 'isShow'">
            <div class="info">
              <div class="persion" :style="{ width: flag2 ? '0' : '36%' }">
                <span style="font-weight: 600; font-size: 16px">双屏录入</span>
                <div style="display: flex; justify-content: center" class="peoplePic">
                  <img src="../../assets/image/icon/avatar60.png" alt />
                  <div style="margin-left: 20px; text-align: left">
                    <span class="span-name">{{ persionInfo.Name }}</span>
                    <span class="span-text">{{ persionInfo.Age }}岁</span>
                    <span class="span-text">{{ persionInfo.Sex == 1 ? '男' : '女' }}</span>
                    <img src="../../assets/image/icon/boy-sex.png" alt v-if="persionInfo.Sex == '1'" />
                    <img src="../../assets/image/icon/female-sex.png" alt v-else />
                    <div>
                      <span class="span-text">{{ persionInfo.Tel }}</span>
                    </div>
                  </div>
                </div>
                <div style="margin-top: 20px">
                  <el-table :data="ArchiveInfo" style="width: 100%;height: 793px;overflow: auto;">
                    <el-table-column prop="Name" label="病例标题"></el-table-column>
                    <el-table-column label="资料">
                      <template #default="{ row }">
                        <div v-for="(item, index) in row.ProjectPatientArchiveAttEntities" :key="index" class="file"
                          @click="handlePreviewFile(item)">{{ item.Name }}{{ item.Suffix }}</div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="file_info" :style="{ width: flag2 ? '100%' : '64%' }">
                <el-button icon="el-icon-arrow-left" class="btn" @click="hc"></el-button>
                <span style="font-weight: 600; font-size: 16px">患者档案</span>
                <div v-if="checkedFile === ''" class="no-caseData">
                  <img src="../../assets/image/icon/img-case.png" />
                  <p>点击左侧患者列表查看档案</p>
                </div>
                <div v-else class="caseData-info">
                  <iframe
                    v-if="!(checkedFile.Suffix === '.jpg' || checkedFile.Suffix === '.jpeg' || checkedFile.Suffix === '.png')"
                    :src="checkedFile.Path" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div>
              </div>
            </div>
            <el-button :icon="isShow && 'el-icon-arrow-left'" size="mini" @click="isShow = !isShow" class="isShow_btn"
              style="height: 80px; width: 40px; text-align: center; padding: 0">
              <span style="writing-mode: tb-rl; font-size: 16px" v-if="!isShow">双屏录入</span>
            </el-button>
            <iframe :src="Url" frameborder="0" width="100%" height="100%" ref="myFrame"></iframe>
          </div>
        </el-dialog>
      </div>
      <el-drawer :visible.sync="detailsDrawer" direction="rtl" :wrapperClosable="false" size="1920px">
        <div slot="title" class="header-title">
          <i class="el-icon-right" style="font-size: 20px; margin-left: 16px; margin-right: 21px"
            @click="detailsDrawer = false"></i>
          <span style="margin-right: 237px">随访记录</span>
          <span>随访详情</span>
        </div>
        <div class="detailsDrawer-components">
          <task-details :ProjectObj="ProjectObj" :PObj="PObj" v-if="detailsDrawer"></task-details>
        </div>
      </el-drawer>
      <div class="QuestionnaireTable">
        <el-dialog :visible.sync="PdialogVisible" :width="devicePixelRatio ? '30%' : '60%'">
          <div slot="title">
            <span style="color: #fff">批量导入</span>
          </div>
          <div>
            <p style="font-size: 16px; margin-bottom: 10px">项目列表</p>
            <el-select v-model="Pvalue" placeholder="请选择">
              <el-option v-for="(item, index) in QProject" :key="index" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
          </div>
          <div slot="footer" class="btn">
            <button @click="PdialogVisible = false">取 消</button>
            <button type="primary" @click="Pdetermine">确 定</button>
          </div>
        </el-dialog>
      </div>
      <div class="QuestionnaireTable">
        <el-dialog :visible.sync="robotVisible" :width="!devicePixelRatio ? '30%' : '60%'">
          <div slot="title">
            <span style="color: #fff">拨打</span>
          </div>
          <div>
            <p style="font-size: 16px; margin-bottom: 10px">机器人列表</p>
            <el-select v-model="obj.RobotId" placeholder="请选择" maxlength="10" minlength="2">
              <el-option v-for="(item, index) in ruleLIst" :key="index" :label="item.Name" :value="item.Id"></el-option>
            </el-select>
          </div>
          <div slot="footer" class="btn">
            <button @click="robotVisible = false">取 消</button>
            <button type="primary" @click="ExecuteOnce">确 定</button>
          </div>
        </el-dialog>
      </div>
      <!-- <div style="margin-left: 15px;margin-top: 10px">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="this.count"
          :page-size="this.num"
          :current-page="this.corr"
          @current-change="handle"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>-->
    </div>
  </div>
</template>
<script>
import PatientCenter from '@/api/PatientCenter';
import AddLabel from '@/components/PatientList/AddLabel';
import AddPatient from '@/components/PatientList/AddPatient'; //打开新增患者
import { mapState } from 'vuex';
import ProjectManagement from '../../api/ProjectManagement';
import derive from '../../api/derive.js';
import Pagination from '../../components/Pagination/index.vue';
import TaskDetails from '../../components/task/TaskDetails.vue';
import { local } from '../../utils/storage';
// import Vconsole from 'vconsole';
export default {
  data() {
    return {
      obj: {
        ProjectId: '',
        RobotId: '',
        ProjectPatientIds: []
      },
      robotVisible: false,
      PdialogVisible: false,
      Pvalue: '',
      admin: local.get('UserId'),
      PatientList: '',
      detailsDrawer: false,
      QuestionnaireFillingDialog: false,
      PatientTable: [],
      StartTime: '', //开始时间
      EndTime: '', //结束时间
      keyword: '', //关键字
      Excel: [],
      Project: [
        {
          Name: '全部',
          Id: 'all'
        },
        {
          Name: '其他',
          Id: 'other'
        }
      ],
      value: '', //项目id
      dialogVisible: false,
      QuestionnaireTable: [],
      ItemList: [],
      Qval: '',
      PObj: '', //储存患者对象
      CObj: '', //随访次数对象
      Url: '',
      ProjectObj: {},
      total: 0,
      listQuery: {
        Key: '',
        page: 1,
        rows: 10
      },
      activityMultipleSelection: [],
      ruleLIst: [], //机器人列表,
      QProject: [],
      border: 0,
      devicePixelRatio: false,
      direction: false,
      flag: false,
      scrollTop: 0,
      scrollLeft: 0,
      persionInfo: {},
      ArchiveInfo: [],
      UserName: local.get('UserName'),
      checkedFile: '',
      isShow: true,
      flag2: false
    };
  },
  computed: mapState(['dialogFlag']),
  mounted() {
    this.devicePixelRatio = document.documentElement.clientWidth < 1100;
  },
  created() {
    //     new Vconsole();

    this.value = {
      Id: 'all',
      Name: '全部'
    };
    this.ProjectList();
    window.addEventListener('message', e => {
      if (e.data == true) {
        console.log(123456);
        // this.RefreshFollowUpRecords();
      }
    });
  },
  components: {
    AddLabel,
    AddPatient,
    TaskDetails,
    Pagination
  },
  methods: {
    handlePreviewFile(item) {
      this.checkedFile = item;
    },
    //患者列表
    async PatientProfiling() {
      const parameter = {
        id: this.persionInfo.Id
      };
      ProjectManagement.PatientProfilingData(parameter).then(res => {
        if (res.data.Status == 1) {
          this.ArchiveInfo = res.data.Data.ArchiveInfo;
          this.ArchiveInfo.forEach(i => (i.UserName = this.UserName));
          this.BaseInfo = res.data.Data.BaseInfo;
        } else {
          alert(res.data.Message);
        }
      });
    },
    sortByVesselName(obj1, obj2) {
      if ([obj1.Name, obj2.Name][0] == [obj1.Name, obj2.Name].sort((a, b) => a.localeCompare(b, 'zh', { sensitivity: 'accent' }))[0]) {
        return -1;
      } else {
        return 1;
      }
    },
    sortByRisk(obj1, obj2) {
      if (obj2.RiskRating > obj1.RiskRating) {
        return 1;
      } else {
        return -1;
      }
      // console.log(obj1.RiskRating)
    },
    dialAll() {
      if (this.obj.ProjectId == '') {
        this.border = 1;
        return this.$message({
          message: '请先在被选中的红色框中选择一个项目',
          type: 'warning'
        });
      }
      if (this.activityMultipleSelection.length == 0) {
        return this.$message({
          message: '请先勾选一个患者',
          type: 'warning'
        });
      }
      //新增打开对话框清空obj.RobitId
      this.obj.RobotId = '';
      this.GetRobotList(this.obj.ProjectId);
      this.robotVisible = true;
    },
    TemplateDownload() {
      ProjectManagement.TemplateDownloadData().then(res => {
        if (res.data.Status == 1) {
          this.downLoad(res.data.Data);
        } else {
          alert(res.data.Message);
        }
      });
    },
    downLoad(record) {
      // console.log('record.httpAddress: ', record.httpAddress)
      const link = document.createElement('a');
      //_blank表示在新窗口打开链接
      link.target = '_blank';
      link.href = record;
      document.body.appendChild(link);
      link.click();
      // document.body.removeChild(link) // 下载完成移除元素
    },
    AddRobotIdDialog(row) {
      this.obj.ProjectId = row.ProjectId;
      this.obj.ProjectPatientId = row.Id;
      this.GetRobotList(row.ProjectId);
      this.robotVisible = true;
    },
    //拨打
    ExecuteOnce() {
      if (this.obj.RobotId == '') {
        return this.$message({
          message: '请选择一个机器人',
          type: 'warning'
        });
      }
      this.activityMultipleSelection.forEach(item => {
        this.PatientTable.forEach(p => {
          if (p.Id == item.Id) {
            this.obj.ProjectPatientIds.push(p.Id);
          }
        });
      });
      ProjectManagement.ExecuteOnceData(this.obj).then(res => {
        if (res.data.Status == 1) {
          this.ProjectList();
          this.$message({
            type: 'success',
            message: '拨打成功!'
          });
          this.robotVisible = false;
        } else {
          alert(res.data.Message);
        }
      });
    },
    //机器人列表
    GetRobotList(ProjectId) {
      ProjectManagement.GetRobotListData(ProjectId).then(res => {
        if (res.data.Status == 1) {
          this.ruleLIst = res.data.Data;
        } else {
          alert(res.data.Message);
        }
      });
    },
    async AddPatientDialog(row) {
      let res = await derive.PatientCenterGet(row.Id);
      this.PatientList = res.data.Data;
      console.log(this.PatientList);
      this.$store.commit('dialogFlagFn', true);
    },
    PatientPortrait(row) {
      this.$router.push({
        path: '/PatientPortrait',
        query: { Id: this.$route.query.Id, qId: row.Id }
      });
    },
    DelFn(data) {
      this.PatientTable.forEach(item => {
        if (item.Id == data.ProjectPatientId) {
          item.LabelNameList = item.LabelNameList.filter(row => {
            return row != data.Name;
          });
        }
      });
    },
    AddFn(data) {
      this.PatientTable.forEach(row => {
        if (row.Id == data.ProjectPatientId) {
          row.LabelNameList.push(data.Name);
        }
      });
    },
    //选中方法
    // handleActivitySelectionChange(selection){
    //     //this.activityMultipleSelection自己定义的接受数组
    //   this.activityMultipleSelection = selection
    //   if (selection.length > 1) {
    //     let del_row = selection.shift()
    //     this.$refs.multipleTable.toggleRowSelection(del_row, false)
    //   }
    // },
    //判断选中数量
    selectAll(selection) {
      this.obj.ProjectPatientIds = [];
      this.activityMultipleSelection = selection;
      //  selection.forEach(item=>{
      //     this.obj.ProjectPatientIds.push(item.Id)
      //  })
    },
    arrselectAll(selection) {
      this.obj.ProjectPatientIds = [];
      this.activityMultipleSelection = selection;
    },
    //打开随访记录弹框
    FollowUpRecords(row) {
      this.PObj = row;
      this.$store.commit('SubmenuFn', true);
      this.detailsDrawer = true;
    },
    //userId="患者id"
    //userName="患者名字"
    //fillinId="登录人id"
    //fillinName="登录人姓名"
    //phone="电话"
    //visitsNumber="方式次数"
    determine() {
      if (this.Qval != '') {
        // console.log(this.Qval);
        // console.log(this.CObj);
        // let Frq=null
        // if(this.CObj.Frq==null){
        //     Frq=0
        // }else{
        //     Frq=this.CObj.Frq
        // }
        this.QuestionnaireFillingDialog = true;
        this.dialogVisible = false;
        this.Url = `${window.global_config.BASE_URL1}/#/PcIframe?sysData=${this.PObj.CallBackInfo.CallBackParameterEncrypt}&type=4&qid=${this.Qval}&userId=${this.PObj.Id}&userName=${this.PObj.Name
          }&fillinId=${local.get('UserId')}&fillinName=${local.get('UserName')}&phone=${this.PObj.Tel}&visitsNumber=${this.CObj}&timestamp=${new Date().getTime()}`;
        // console.log(this.Url);
        // const parameter={
        //     ProjectId:this.PObj.ProjectId
        // }
        // console.log(this.PObj);
        // questionnaire.CallBackQuestionnaireData(parameter).then(res=>{
        //             console.log(res,"xxxxx");
        //             // let a=JSON.parse(res.data.Data)
        //             // console.log(a.ProjectId);
        //             if(res.data.Status==1){
        //                   this.QuestionnaireFillingDialog=true
        //                   this.dialogVisible=false
        //                   this.Url=`${window.global_config.BASE_URL1}/#/P?sysData=${res.data.Data}&type=1&qid=${this.Qval}&userId=${this.PObj.Id}&userName=${this.PObj.Name}&fillinId=${local.get('UserId')}&fillinName=${local.get('UserName')}&phone=${this.PObj.Tel}&visitsNumber=${this.CObj}`
        //             }else{
        //                 alert(res.data.Message)
        //             }
        // })
      }
    },
    //选择问卷后调用随访接口
    QuestionnaireTableChange(e) {
      if (e.issueState == false) {
        this.Qval = '';
        alert('请先去发布问卷');
      }
    },
    //项目选择后的回调
    ProjectChange(item) {
      this.obj.ProjectId = '';
      if (item.Id == 'all' || item.Id == 'other') {
        local.set('IsRtc', true);
      } else {
        this.obj.ProjectId = item.Id;
        local.set('IsRtc', item.IsRtc);
      }
      this.ProjectGetPageList(item.Id);
    },
    //项目
    async ProjectList() {
      derive.ProjectListData().then(res => {
        if (res.data.Status == 1) {
          if (res.data.Data.length != 0) {
            this.QProject = JSON.parse(JSON.stringify(res.data.Data));
            // this.Project=res.data.Data;
            //初始化Project
            this.Project = [
              {
                Name: '全部',
                Id: 'all'
              },
              {
                Name: '其他',
                Id: 'other'
              }
            ];
            res.data.Data.forEach(item => {
              this.Project.push(item);
            });

            // let Objall={
            //     Name:"全部",

            //     Id:"all",
            // }
            // let ObjOther={
            //     Name:"其他",
            //     Id:"other",
            // }
            this.value = {
              Id: 'all',
              Name: '全部'
            };
            local.set('IsRtc', true);
            // this.Project.unshift(ObjOther)
            // this.Project.unshift(Objall)
            this.ProjectGetPageList(this.value.Id);
          }
        } else {
          alert(res.data.Message);
        }
      });
    },
    //打开问卷填写
    QuestionnaireFilling(row) {
      const h = this.$createElement;
      this.$confirm('', {
        message: h('div', null, [
          h('i', {
            class: 'el-icon-question',
            style: 'color:#f90;font-size:30px;'
          }),
          h(
            'span',
            {
              style: 'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;'
            },
            '提示'
          ),
          h('p', { style: 'margin:10px 0 0 40px;font-size:20px' }, '是否新增一份问卷吗？'),

          h(
            'p',
            {
              style: 'text-align: center;line-height:18px;position: absolute;bottom:-110px'
            },
            [h('span', { style: 'color:red;font-weight:800' }, '温馨提示: '), h('span', {}, '如果想要继续填写“已填写过的问卷”，请到“已收集问卷”或“随访记录”中继续填写即可!')]
          )
        ]),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'diyModel',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        if (!row.CallBackInfo.IsSuccess) {
          alert(row.CallBackInfo.Msg);
          return;
        }
        if (row.ProjectId == null) {
          alert('该患者不属于任何项目,无法填写问卷');
        } else {
          this.persionInfo = row;
          this.PObj = row;
          this.dialogVisible = true;
          this.Url = '';
          this.Qval = '';
          this.QuestionnaireGetPageList(row.ProjectId);
          this.PatientProfiling();
        }
      });
    },
    //问卷列表分页
    QuestionnaireGetPageList(ProjectId) {
      const parameter = {
        ProjectId: ProjectId
      };
      derive.CRFSurfaceData(parameter).then(res => {
        if (res.data.Status == 1) {
          this.QuestionnaireTable = res.data.Data;
        } else {
          alert(res.data.Message);
        }
      });
    },
    //重置
    Reset() {
      // this.value.Id = 'all';
      // this.value.Name = '全部';
      this.value = this.Project[0];
      this.listQuery.Key = '';
      this.keyword = '';
      this.StartTime = '';
      this.EndTime = '';
      this.ProjectGetPageList('all');
    },
    //搜索GetPageList
    query() {
      this.listQuery.Key = this.keyword;
      this.listQuery.page = 1;
      this.ProjectGetPageList(this.value.Id);
    },
    //打开导入
    chooseFile() {
      this.$refs.file.value = '';
      this.Pvalue = '';
      this.PdialogVisible = true;
    },
    Pdetermine() {
      this.PdialogVisible = false;
      this.$refs.file.click();
    },
    // 思路：对于原数组每个对象来说
    //    （1） 找出所有的中文key
    //     (2)  得到对应的英文key
    //     (3)  拼接一个新对象： 英文key:值
    transExcel(results) {
      // 首先需要一个我们写好的用来映射的对象或数组
      const mapInfo = {
        患者编号: 'No',
        医保卡号: 'MiCardNo',
        '患者姓名（必填）': 'Name',
        名字缩写: 'NameAbbr',
        '就诊日期（日期格式2020-09-25）': 'VisitDate',
        '患者电话（必填）': 'Tel',
        '证件类型（00=身份证 01=军官证 02=护照 03=其它）请填写对应的数字': 'CertType',
        证件号码: 'CertNo',
        '出生日期（日期格式2020-09-25）': 'Birthday',
        年龄: 'Age',
        '性别（1=男 0=女）请填写对应的数字': 'Sex',
        '身高（m）': 'Height',
        '体重（kg）': 'Weight',
        '教育程度（00=文盲 01=小学 02=初中 03=中专及高中 04=大专 05=本科 06=硕士及以上）请填写对应的数字': 'Edu',
        患者微信: 'WX',
        患者QQ: 'QQ',
        '紧急联系人姓名（必填）': 'EcName',
        紧急联系人电话: 'EcTel',
        '风险等级（01=正常 02=低风险 03=中风险 04=高风险）请填写对应的数字': 'RiskRating',
        住院病区: 'Ward',
        住院天数: 'Day',
        '出院日期（日期格式2020-09-25）': 'DischargeDate',
        出院诊断: 'DischargeDiagnosis',
        '出院方式（00=同意出院 01=自动出院 02=转院 03=逃逸出院）请填写对应的数字': 'DischargeMode',
        主治医生: 'AttendingDoctor',
        随访医生: 'FollowUpDoctor',
        随机号: 'RandomNumber',
        组别号: 'GroupNumber',
        '患者来源（00=测试来源1 02=测试来源2 03=测试来源3）请填写对应的数字': 'Source',
        患者地址: 'Address'
      };
      return results.map(zhObj => {
        // 首先创建一个空对象来逐个接收转换后的key
        const enObj = {};

        // 使用Object.keys方法来获取中文的key
        const zhKeys = Object.keys(zhObj); // ['姓名', '手机号']

        // 用forEach循环来将key逐个映射(map)出去
        zhKeys.forEach(zhKey => {
          const enKey = mapInfo[zhKey]; // 如果是一个对象具体的某个属性,就用 对象.(属性),此处非确切值,则为 对象[属性] 写法

          enObj[enKey] = zhObj[zhKey]; // 将空对象所需要接收的值传入
        });

        return enObj;
      });
    },
    //导入
    getFile(e) {
      let fd = new FormData();
      fd.append('file', e.target.files[0]);
      fd.append('ProjectId', this.Pvalue);
      ProjectManagement.PatientExportData(fd).then(res => {
        if (res.data.Status == 1) {
          this.$message({
            type: 'success',
            message: res.data.Message
          });
          this.ProjectList();
        } else {
          alert(res.data.Message);
        }
      });
    },
    //编辑
    Editfather(data) {
      this.PatientTable = this.PatientTable.map(item => {
        if (item.Id == data.Id) {
          item = data;
        }
        return item;
      });
    },
    //新增患者
    Addfather(data) {
      this.PatientTable.unshift(data);
      this.ProjectGetPageList(this.value.Id);
    },
    //项目患者列表
    ProjectGetPageList(Id) {
      const parameter = {
        projectId: Id,
        Key: this.listQuery.Key,
        page: this.listQuery.page,
        rows: this.listQuery.rows,
        BeginTime: this.StartTime,
        EndTime: this.EndTime
      };
      ProjectManagement.QGetPageListData(parameter).then(res => {
        if (res.data.Status == 1) {
          this.PatientTable = res.data.Data.rows.map(item => {
            item.CreateTime = item.CreateTime.substring(0, 10);
            if (item.Birthday) {
              item.Birthday = item.Birthday.substring(0, 10);
            }
            return item;
          });
          this.total = res.data.Data.total;
          this.$nextTick(() => {
            this.activityMultipleSelection.forEach(row => {
              this.PatientTable.forEach(p => {
                if (p.Id == row.Id) {
                  this.$refs.multipleTable.toggleRowSelection(p);
                }
              });
            });
          });
        } else {
          alert(res.data.Message);
        }
      });
    },
    //删除患者
    DeletePatient(row) {
      const parameter = [];
      parameter.push(row.Id);
      this.$confirm('删除后将无法恢复，请问你确定要删除该患者吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        PatientCenter.DeletePatientData(parameter).then(res => {
          if (res.data.Status == 1) {
            this.PatientTable = this.PatientTable.filter(item => {
              return item.Id != row.Id;
            });
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.ProjectGetPageList(this.value.Id);
          } else {
            alert(res.data.Message);
          }
        });
      });
    },
    hc() {
      this.flag2 = !this.flag2;
    },
    move(e) {
      console.log(e);
      e.preventDefault();
      // 获取元素
      var left = document.querySelector(".tolead");
      var img = document.querySelector(".img");
      var x = e.pageX - img.offsetLeft;
      var y = e.pageY - img.offsetTop;
      // 添加鼠标移动事件
      left.addEventListener("mousemove", move);
      function move(e) {
        img.style.left = e.pageX - x + "px";
        img.style.top = e.pageY - y + "px";
      }
      // 添加鼠标抬起事件，鼠标抬起，将事件移除
      img.addEventListener("mouseup", function () {
        left.removeEventListener("mousemove", move);
      });
      // 鼠标离开父级元素，把事件移除
      left.addEventListener("mouseout", function () {
        left.removeEventListener("mousemove", move);
      });
    },
    // 缩放图片
    rollImg() {
      /* 获取当前页面的缩放比 若未设置zoom缩放比，则为默认100%，即1，原图大小 */

      var zoom = parseInt(this.$refs.imgDiv.style.zoom) || 100;
      /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动 */

      zoom += event.wheelDelta / 12;
      /* 最小范围 和 最大范围 的图片缩放尺度 */

      if (zoom >= 80 && zoom < 500) {
        this.$refs.imgDiv.style.zoom = zoom + "%";
      }
      return false;
    },
    handleClose(){
      console.log(1);
      this.checkedFile.Path = '';
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../styles/mixin.scss';

.item_p {
  padding-top: 20px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #f2f2f2;
  }
}

.file {
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #f2f2f2;
  }
}

.no-caseData {
  width: 288px;
  text-align: center;
  margin: 121px auto 0 auto;

  p {
    width: 288px;
    font-size: 16px;
    font-weight: 400;
    line-height: 27px;
    color: #aaafb5;
  }
}

.caseData-info {
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: auto;
  height: 100%;

  p {
    @include common_span;
  }

  span {
    @include common_span;
    @include add-size5($font_size_14);
  }

  .time {
    @include add-size($font_size_16);
    color: #3388ff;
  }

  .bei-p {
    @include add-size5($font_size_14);
  }
}

.question {
  display: grid;
  grid-template-columns: 0.8fr auto 1fr;
  height: 100%;
  transition: 0.3s;

  .info {
    transition: 0.3s;
    display: flex;
    height: 100%;
    overflow: hidden;

    &>div:first-child {
      width: 36%;
    }

    &>div:last-child {
      position: relative;
      width: 64%;

      .btn {
        position: absolute;
        top: 0;
        left: 0px;
        height: 80px;
        width: 40px;
        text-align: center;
        padding: 0px;
      }
    }

    &>div {
      border-right: 1px solid #ccc;
      text-align: center;
    }

    .persion {
      transition: 0.3s;
      overflow: hidden;
    }
  }
}

.isShow {
  grid-template-columns: 0fr auto 1fr !important;
}

// .btn {
//   top: 1vw;
//   left: 1vw;
// }
.peoplePic {
  margin-left: 0 !important;
  margin-top: 15px !important;
}

.span-name {
  font-size: 24px;
  font-weight: 500;
  line-height: 41px;
  color: #585858;
  margin-right: 24px;
}

.span-text {
  @include common_span;
}

// /deep/ .el-link--inner {
//   margin-right: 11px;
// }

.el-table__fixed-right {
  right: 0px !important;
  background-color: #fff;
}

.classborder {
  border: 1px solid red;
}

.tag_span {
  display: inline-block;
  min-width: 80px;
  height: 26px;
  background-color: #409eff;
  border: 1px solid #b3d8ff;
  border-radius: 4px;
  line-height: 24px;
  // color: #409eff;
  color: #fff;
  padding: 0 10px;
  box-sizing: border-box;
  margin-bottom: 8px;
  margin-left: 4px;
  font-size: 12px;
}

.QuestionnaireFilling {
  /deep/.el-dialog__body {
    height: 94%;
    padding: 0;
  }

  /deep/.el-dialog__headerbtn {
    top: 8px;
  }
}

.span-h {
  cursor: pointer;
}

.QuestionnaireTable {
  width: 100%;
}

.el-select {
  width: 100%;
}

.QuestionnaireTable {
  /deep/.el-input__inner {
    // width: 100%;
    // min-width: 400px;
    // width: 540px;
    height: 40px;
    line-height: 40px;
  }

  /deep/.el-input {
    height: 40px;
  }
}

/deep/.el-input {
  height: 30px;
}

/deep/.el-input__inner {
  width: 100%;
  height: 30px;
}

/deep/.el-form-item__content {
  height: 34px;
}

/deep/.el-button {
  height: 34px;
  font-weight: 400;
  @include add-size5($font_size_14);
}

/deep/.el-button--primary {
  @include common_button_primary;
  margin-left: 20px;
}

/deep/.el-input__icon {
  line-height: 20px;
  width: 20px;
}

.tolead {
  width: 100%;
  height: 100%;
  min-width: 1440px;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .title {
    background-color: #ffffff;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .left {
      margin-top: 14px;
      margin-bottom: 1%;
      margin-left: 1%;
      width: 99%;
      display: flex;

      // justify-content: center;
      // align-items: center;
      .yuan {
        display: flex;
        align-items: center;
        height: 34px;
        // /deep/.el-tag {
        //   border-radius: 50% !important;
        //   width: 20px;
        //   height: 20px;
        //   vertical-align: middle;
        // }
        float: right;
        margin-right: 20px;

        span {
          @include common_span;
        }
      }

      span {
        display: inline-block;
        @include common_span;
        margin-left: 6px;
        margin-right: 6px;
      }

      /deep/.el-input__inner {
        height: 34px;
        line-height: 20px;
        border-radius: 4px;
        @include add-size($font_size_16);
      }

      /deep/.el-input {
        margin-right: 10px;
        // width: 200px;
        height: 34px;
      }

      /deep/.el-input__inner {
        height: 34px;
      }

      /deep/.el-button.czhi {
        @include common_button_plain;
      }
    }

    .right {
      width: 98%;
      margin: 0 auto 10px auto;
      display: flex;
      justify-content: space-between;

      //position: relative;
      /deep/.el-button.export-img-btn {
        @include common_button_plain;
      }

      /deep/.el-button.dao-ru {
        @include common_button_primary;

        img {
          vertical-align: 0;
        }
      }

      .se2 {
        display: none;
      }
    }
  }

  .wenid {
    .wenidselect {
      width: 300px;
      height: 30px;
    }
  }
}

.con {
  height: 86%;
  margin-bottom: 10px;

  /deep/.el-tag {
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }

  .fen-rigth {
    width: 40%;

    input {
      width: 30px;
      height: 26px;
      margin-left: 1%;
      margin-right: 1%;
      border: 0;
      text-align: center;
      border-radius: 10%;
      font-size: 16px;
    }

    .span1-rigth {
      color: rgb(19, 104, 171);
    }
  }
}

.content {
  height: 700px;
  padding-top: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  height: 100%;
}

.box1 {
  width: 50%;
  height: 40px;

  .box1-span1 {
    width: 36%;
    display: inline-block;
    text-align: right;
  }

  .box1-span2 {
    width: 56%;
    display: inline-block;
    margin-left: 2%;

    /deep/.el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 180px;
    }

    /deep/.el-input {
      width: 85%;
    }

    /deep/.el-input__inner {
      width: 97%;
      height: 28px;
    }

    /deep/.el-input__icon {
      line-height: 28px;
    }

    /deep/.el-radio-group .el-radio {
      width: 38px;

      .el-radio__label {
        padding-left: 4%;
      }
    }

    /deep/.el-radio {
      margin-right: 0;
    }

    /deep/#select {
      width: 104px;
    }

    /deep/#select1 {
      width: 104px;
    }
  }

  input {
    height: 26px;
    border-radius: 6px;
    outline: none;
  }
}

.box22 {
  width: 100%;

  .box1-span1 {
    width: 18%;
  }

  .box1-span2 {
    width: 80%;
    margin-left: 1%;

    input {
      width: 160px;
    }

    /deep/.el-input {
      width: 95%;
    }
  }
}

.box1btn {
  width: 94%;

  /deep/.el-button {
    margin-right: 1%;
    float: right;
  }
}

a {
  color: #3fbc39;
}

//.add_dialog {
//  /deep/.el-dialog{
//    .el-dialog__header {
//      margin-bottom: 0;
//    }
//    /deep/.el-form {
//    .el-input {
//        width: 360px;
//      }
//    .el-input__inner {
//        width: 360px;
//      }
//    .el-select {
//        .el-input__inner {
//          width: 360px;
//        }
//      }
//    }
//    .btn {
//      margin-top: 10px;
//    }
//  }
//}
.call-phone {
  /deep/.el-dialog {
    .el-dialog__body {
      padding: 0;
    }

    .el-dialog__header {
      width: 0;
      height: 0;
      padding: 0;
    }
  }
}

/deep/.el-drawer {
  height: 100%;

  .el-drawer__header {
    padding: 0 20px 0 0;
    margin: 0;
  }

  .detailsDrawer-components {
    background: #f3f4f5;
    box-shadow: 0 3px 20px rgba(0, 0, 0, 0.16);
  }

  .header-title {
    width: 1201px;
    height: 60px;
    background: #ffffff;
    opacity: 1;
    line-height: 60px;
  }
}

/deep/.el-button.yijian {
  @include common_button_plain;
  background: rgba(57, 120, 231, 0.15);
  border: 1px solid rgba(51, 136, 255, 0.5686274509803921);
}

@media screen and (-webkit-min-device-pixel-ratio: 1.5) {
  .tolead {
    min-width: 0 !important;

    .title {
      /deep/.el-button--primary {
        margin-left: 0 !important;
        margin-right: 10px !important;
      }

      .left {
        flex-wrap: wrap;
        justify-content: space-between;

        .project {
          width: 150px !important;
          margin-right: 0 !important;
        }

        .timer {
          span {
            width: 40px !important;
          }

          /deep/.el-input {
            width: 143px !important;
          }
        }

        .KeyWord {
          width: 150px !important;

          /deep/.el-input {
            margin-right: 0 !important;
          }

          span {
            white-space: nowrap;
          }

          .el-input {
            width: none !important;
          }
        }

        .yuan {
          justify-content: flex-end;
          margin-right: 0 !important;
          width: 100% !important;
        }
      }
    }

    .content {
      flex: 1;
      display: flex;
      flex-direction: column;

      .con {
        height: 90% !important;

        /deep/.el-table__fixed-right-patch {
          width: 9px !important;
          background-color: rgb(240, 247, 253) !important;
        }
      }

      .robotVisibledia {
        width: 60% !important;
      }

      // /deep/.el-dialog{
      //
      // }

      .QuestionnaireTable {
        /deep/.el-dialog {
          width: 60% !important;
        }
      }
    }

    /deep/ .el-drawer {
      width: 100% !important;

      .detailsDrawer-components {
        height: 100%;

        .task-details-right {
          flex: 1;
        }
      }
    }
  }
}

.imgBox {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.img {
  position: absolute;
  top: 80px;
  left: 350px;
  max-width: 450px;
  max-height: 460px;
  cursor: move;
  z-index: 99900 !important;
}
</style>
